import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
    palette: {
        primary: {
            main: "#EA650D",
            contrastText: "#FFFFFF"
        }
    },
    typography: {
        fontFamily: "NNNittiGrotesk, Helvetica, Arial, sans-serif;",
        button: {
            fontSize: "1rem",
            fontWeight: 400,
            height: "1.7rem",
            textTransform: "unset",
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    "&:hover": {
                        backgroundColor: "#C6C5C5", // Change this to your desired hover color
                    },
                },
            },
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    height: "1.8rem",
                    paddingBottom: "0.1rem",
                    paddingTop: "0.1rem",
                    "&:hover": {
                        backgroundColor: "#C6C5C5",
                    }
                }
            }
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    padding: "4px",
                    width: "25px",
                    height: "25px",
                    "&:hover": {
                        backgroundColor: "#C6C5C5",
                    },
                    "& img": {
                        width: "100%",
                    },
                },
            }
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    marginTop: 0,
                }
            }
        }
    },
});
